// React
import React from "react";

// Libraries
import PropTypes from "prop-types";
import { Icon, Button } from "semantic-ui-react";
import mime from "mime";

// Components
import Text from "@Components/Text";

// Styles
import styles from "./styles.module.css";

const DocumentCard = ({ fileName, withButton = false, onClick }) => {
	const getIcon = () => {
		const extension = mime.getType(fileName);
		switch (extension) {
			case "text/plain":
			case "application/msword":
			case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
				return "file word outline";

			case "text/csv":
			case "application/vnd.ms-excel":
			case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
				return "file excel outline";

			case "application/vnd.ms-powerpoint":
			case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
				return "file powerpoint outline";

			case "image/jpeg":
			case "image/webp":
			case "image/jpg":
				return "file image outline";

			case "video/mp4":
			case "video/quicktime":
			case "video/x-msvideo":
			case "video/x-matroska":
				return "file video outline";

			case "audio/mpeg":
			case "audio/wav":
			case "audio/x-m4a":
			case "audio/ogg":
				return "file audio outline";

			case "application/zip":
			case "application/vnd.rar":
			case "application/vnd.microsoft.portable-executable":
			case "application/vnd.android.package-archive":
				return "file archive outline";

			case "application/pdf":
				return "file pdf outline";

			default:
				return "file outline";
		}
	};

	return (
		<div className={styles.document}>
			<Icon className={styles.fileIcon} name={getIcon()} />
			<Text className={styles.text}>{fileName}</Text>
			{withButton && (
				<Button className={styles.button} onClick={onClick}>
					<Icon className={styles.icon} name="download" />
					Descargar
				</Button>
			)}
		</div>
	);
};

DocumentCard.propTypes = {
	fileName: PropTypes.string,
	withButton: PropTypes.bool,
	onClick: PropTypes.func,
};

export default DocumentCard;
